import React, { useCallback, useLayoutEffect } from 'react';
import { StyleSheet } from 'react-native';
import Animated from 'react-native-reanimated';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { AppView } from 'design-system/AppView';
import HeaderImage from 'design-system/HeaderImage';
import Button, { HEIGHT } from 'design-system/Button';
import { rem, SCROLL_INDICATOR_INSETS } from 'design-system/values';
import NavigationCloseButton from 'design-system/NavigationCloseButton';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { useAppSelector } from 'store/hooks';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { selectTradingAccount } from '../reducers/selectors';
import { AccountTypeDisplayLong } from '../constants';
import { isWeb } from '../../../constants';
const graphics = require('../img/stock-info.png');
export default withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const tradingAccount = useAppSelector(selectTradingAccount);
    const paddingBottom = useMarginBottom('paddingBottom', HEIGHT + rem(16), styles.contentContainer, paddingHorizontalStyle);
    const handleGoBack = useCallback(() => {
        navigation.goBack();
    }, []);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerLeft: () => <NavigationCloseButton inWebHeader onPress={handleGoBack}/>,
            headerBackVisible: false,
        });
    }, [handleGoBack]);
    if (!tradingAccount) {
        return null;
    }
    return (<AppView withFrame={false}>
        <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} contentContainerStyle={paddingBottom} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
          <HeaderImage style={styles.headerImgBg} source={graphics} imgStyle={styles.headerImage} onDark/>
          <Text Text-16 Secondary>
            Before we can close your account...
          </Text>
          <Spacer h={8}/>
          <Text Text-24>Sell your holdings, then withdraw your balance</Text>
          <Spacer h={8}/>
          <Text TextThin-16 Secondary>
            Once done, come back here to close your{' '}
            {AccountTypeDisplayLong[tradingAccount.account.accountType] || 'trading account'}
          </Text>
        </Animated.ScrollView>
        <Button floating brand title="Got it" onPress={handleGoBack}/>
      </AppView>);
}, ({ colors }) => ({
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styles = StyleSheet.create({
    contentContainer: {
        paddingTop: rem(16),
        paddingHorizontal: rem(16),
    },
    headerImgBg: {
        height: undefined,
    },
    headerImage: {
        width: '100%',
        aspectRatio: 1,
        height: undefined,
    },
});
